module.exports = [{
      plugin: require('/Users/ben/t/eelaw/node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"gatsby-starter-default","short_name":"starter","start_url":"/","background_color":"#663399","theme_color":"#663399","display":"minimal-ui","icon":"src/images/erezlogo.png"},
    },{
      plugin: require('/Users/ben/t/eelaw/node_modules/gatsby-plugin-intl/gatsby-browser.js'),
      options: {"plugins":[],"path":"/Users/ben/t/eelaw/src/intl","languages":["en"],"defaultLanguage":"en","redirect":false},
    },{
      plugin: require('/Users/ben/t/eelaw/node_modules/gatsby-plugin-google-analytics/gatsby-browser.js'),
      options: {"plugins":[],"trackingId":"UA-146804018-3"},
    },{
      plugin: require('/Users/ben/t/eelaw/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
